var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileTypesApk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDF1F7",
    d: "M21 6h-5.25a.75.75 0 01-.75-.75V0H4.125C3.505-.002 3.002.5 3 1.12v21.755c-.002.62.5 1.123 1.12 1.125h15.755c.62.002 1.123-.5 1.125-1.12V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FC",
    d: "M20.672 4.922L16.082.328A1.122 1.122 0 0015.286 0H15v5.25c0 .414.336.75.75.75H21v-.286a1.12 1.12 0 00-.328-.792z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10.8h12v12H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CEE0",
    d: "M14.342 15.427l.796-1.384a.161.161 0 00-.278-.162l-.806 1.401A4.912 4.912 0 0012 14.843c-.745 0-1.438.157-2.054.44L9.14 13.88a.16.16 0 00-.22-.059.162.162 0 00-.06.221l.797 1.384c-1.373.747-2.303 2.141-2.457 3.774h9.6c-.154-1.632-1.084-3.027-2.458-3.773zm-4.546 2.42a.403.403 0 010-.807.403.403 0 010 .808zm4.407 0a.403.403 0 010-.807.403.403 0 010 .808z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.6 2.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7.2,
    fill: "#23B34A",
    rx: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M1.843 5.4l.269-.835h1.277l.278.835h.62L3.081 2.074h-.634L1.238 5.4h.605zm1.411-1.262H2.251l.5-1.536.503 1.536zM5.29 5.4V4.147h.662c.333 0 .596-.093.79-.278.193-.186.29-.439.29-.759s-.097-.572-.29-.758c-.194-.186-.457-.278-.79-.278H4.718V5.4h.572zm.604-1.704H5.29V2.525h.604c.186 0 .326.05.42.149.095.099.142.244.142.436s-.047.338-.142.437c-.094.1-.234.149-.42.149zM8.213 5.4V3.816L9.605 5.4h.73L8.77 3.643l1.416-1.57h-.672L8.213 3.539V2.074h-.586V5.4h.586z"
  })))));
}

export default SvgFileTypesApk;